import React from 'react'
import './style.css'
import {Link} from 'react-router-dom'

export default function compLinkHeader(props) {
    return (
        <div className={`title-props-back ${props.Ctitle}`}>
                <Link to={props.to}>{props.back}</Link>
                <img src="asset/users/right.svg" alt="right" />
                <h3>{props.title}</h3>
        </div>
    )
}
